import React from "react";
import { Link } from "react-router-dom";
import "./styles/PolicyPages.css";

const RefundPolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Refund Policy</h1>
        <p className="policy-updated">Last updated: February 2026</p>

        <section className="policy-section">
          <h2>Overview</h2>
          <p>VyralNews is committed to providing quality journalism and a fair subscription experience. This refund policy outlines the circumstances under which refunds may be issued for subscription payments.</p>
        </section>

        <section className="policy-section">
          <h2>Cancellations</h2>
          <p>You may cancel your subscription at any time from your <Link to="/user/profile">Profile page</Link>. When you cancel, you will retain access to premium content for the remainder of your current billing period. No partial refunds are issued for unused time within a billing period after cancellation.</p>
        </section>

        <section className="policy-section">
          <h2>Refund Eligibility</h2>
          <p>Refunds may be considered in the following circumstances:</p>
          <ul>
            <li><strong>Duplicate charges</strong> - If you were accidentally charged more than once for the same billing period.</li>
            <li><strong>Technical errors</strong> - If a technical issue on our end prevented you from accessing the content you paid for during a significant portion of your billing period.</li>
            <li><strong>Unauthorized charges</strong> - If a charge was made without your authorization.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Non-Refundable Situations</h2>
          <p>Refunds are generally not provided in the following cases:</p>
          <ul>
            <li>Change of mind after subscribing</li>
            <li>Failure to cancel before a renewal date</li>
            <li>Partial use of a subscription period</li>
            <li>Dissatisfaction with specific article content or editorial decisions</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>How to Request a Refund</h2>
          <p>To request a refund, please contact us at <a href="mailto:info@vyralmediagroup.com">info@vyralmediagroup.com</a> with the following information:</p>
          <ul>
            <li>Your username or email address</li>
            <li>The date and amount of the charge</li>
            <li>The reason for your refund request</li>
          </ul>
          <p>We aim to review and respond to all refund requests within 5 business days.</p>
        </section>

        <section className="policy-section">
          <h2>Refund Processing</h2>
          <p>Approved refunds will be processed through Stripe and returned to the original payment method. Depending on your bank or card issuer, it may take 5-10 business days for the refund to appear on your statement.</p>
        </section>

        <section className="policy-section">
          <h2>Contact Us</h2>
          <p>If you have questions about this refund policy, please contact us at <a href="mailto:info@vyralmediagroup.com">info@vyralmediagroup.com</a>.</p>
        </section>

        <div className="policy-links">
          <Link to="/pricing">Pricing</Link>
          <Link to="/payment-policy">Payment Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
